import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { isMobileFun, getPrefixField, convertStylesStringToObject, createFilePath, isScrollToBottom } from '../../utils/obj-utils';
import './style.scss';

export default function index({ fields, close, scrollElement }) {
  const isMobile = isMobileFun();
  const [hideNext, setHideNext] = useState(false);
  useEffect(() => {
    const element = scrollElement || window;
    const scroll = () => {
      setHideNext(isScrollToBottom(10, element));
    };
    element.addEventListener('scroll', scroll);
    return () => {
      element.removeEventListener('scroll', scroll);
    };
  }, []);
  return (
    <>
      {fields[`${getPrefixField('icon', isMobile)}`]?.value ? (
        <div className="close_v2" style={convertStylesStringToObject(fields[`${getPrefixField('closestyle', isMobile)}`]?.value)}>
          <img
            className="icon"
            src={createFilePath(fields[`${getPrefixField('icon', isMobile)}`]?.value)}
            alt="关闭"
            onClick={() => {
              window.Dmp.clickAction(fields?.dmp?.value);
              close && close();
            }}
          />
        </div>
      ) : null}
      {!hideNext && fields[`${getPrefixField('moreicon', isMobile)}`]?.value ? (
        <div className="moreicon_v1" style={convertStylesStringToObject(fields[`${getPrefixField('morestyle', isMobile)}`]?.value)}>
          <img className="moreicon" src={createFilePath(fields[`${getPrefixField('moreicon', isMobile)}`]?.value)} alt="向下滑动" />
        </div>
      ) : null}
    </>
  );
}
